import ArticleLayout from '@/components/feature/ArticleLayout';
import { beginnersArticle } from '@/mocks/beginnersArticle';

export default function HipobuySpreadsheetBeginners() {
  return <ArticleLayout article={beginnersArticle} slug="hipobuy-spreadsheet-beginners" />;
}